export function normalizeText(value: string | null | undefined): string | null {
  const trimmed = value?.trim() ?? '';
  return trimmed.length > 0 ? trimmed : null;
}

export function chatConversationPath(
  conversationId: string,
  options: { agentGroupId?: string | null } = {}
) {
  const path = `/chat/${encodeURIComponent(conversationId)}`;
  const agentGroupId = normalizeText(options.agentGroupId);
  if (!agentGroupId) {
    return path;
  }
  return `${path}?agentGroupId=${encodeURIComponent(agentGroupId)}`;
}

export function uniqueNormalizedIds(ids: Array<string | null | undefined>) {
  const next: string[] = [];
  const seen = new Set<string>();
  for (const rawId of ids) {
    const id = normalizeText(rawId);
    if (!id || seen.has(id)) continue;
    seen.add(id);
    next.push(id);
  }
  return next;
}

export function isListedConversationKind(
  kind: string | null | undefined
) {
  const normalizedKind = normalizeText(kind);
  return (
    normalizedKind === 'user_chat' ||
    normalizedKind === 'agent_task' ||
    normalizedKind === 'session'
  );
}

export function activityKey(
  agentId?: string | null,
  sessionId?: string | null
): string | null {
  const normalizedAgentId = normalizeText(agentId);
  const normalizedSessionId = normalizeText(sessionId);
  if (!normalizedAgentId || !normalizedSessionId) return null;
  return `${normalizedAgentId}\u001f${normalizedSessionId}`;
}

export function sortConversations<
  T extends { conversationId: string; updatedAt: number },
>(conversations: T[]): T[] {
  return [...conversations].sort((a, b) => {
    if (a.updatedAt === b.updatedAt) {
      return b.conversationId.localeCompare(a.conversationId);
    }
    return b.updatedAt - a.updatedAt;
  });
}
